import { useInjection } from 'inversify-react';
import Cookies from 'js-cookie';
import { useCallback } from 'react';

import { getInkive } from '@desygner/ui-editor-sdk-inkive';

import { ICredentialsManager } from '../../../core/viewer/credentials-manager';
import { IViewerLoader } from '../../../core/viewer/viewer-loader';
import { IConfigStoreInjector, IViewerStoreInjector, TYPES } from '../../../inversify.config';
import { IUserStoreInjector } from '../../../store';
import { Status } from '../../../store/viewer/viewer.types';
import { AureliaAuthModal } from './AureliaLoginModal';
import { LoginModal } from './LoginModal';

export function LoginModalContainer({ flow }: { flow: 'login' | 'revalidate' }) {
  const viewerLoader = useInjection<IViewerLoader>(TYPES.Viewer.ViewerLoader);
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);
  const useUserStore = useInjection<IUserStoreInjector>(TYPES.Store.User);
  const credentialsManager = useInjection<ICredentialsManager>(TYPES.Viewer.CredentialsManager);
  const setUserToken = useUserStore((state) => state.setUserToken);
  const setStatus = useViewerStore((state) => state.setStatus);

  const useConfigStore = useInjection<IConfigStoreInjector>(TYPES.Store.Config);
  const feature = useConfigStore((state) => state.feature);
  const resources = useConfigStore((state) => state.resources);

  const handleLogin = useCallback(
    (userToken: string, userHash?: string, apiKey?: string) => {
      setUserToken(apiKey || userToken);

      Cookies.set('user_token', userToken, {
        sameSite: 'none',
        secure: true,
        domain: resources.cookieDomain,
      });

      if (userHash)
        Cookies.set('user_hash', userHash, {
          sameSite: 'none',
          secure: true,
          domain: resources.cookieDomain,
        });

      if (flow === 'login') {
        setStatus(Status.Loading);
        viewerLoader.loadViewerProject();
      } else {
        viewerLoader.loadUserData().then(() => {
          getInkive().EditorFacade.trigger('user.revalidated');
        });
      }
    },
    [viewerLoader, flow, setStatus, setUserToken]
  );

  if (flow === 'revalidate' && credentialsManager.hasSSOLogin()) return null;

  return feature.legacyLoginModal ? (
    <AureliaAuthModal onLogin={handleLogin} />
  ) : (
    <LoginModal onLogin={handleLogin} />
  );
}
